import Lookup from 'src/componentes/select2';

const TipoCardLookup = (props) => (
  <Lookup labelKey="nome" valueKey="id" url="/TipoCardLookup" {...props} />
);

export default TipoCardLookup;
